import { memo, useState } from "react";
import { View } from "react-native";
import useClearingTimeouts from "src/hooks/useClearingTimeouts";
import { Image } from "src/swsh-native";
import { PromotingImageProps } from "./types";

const PromotingImage = ({
	alt,
	src,
	upgradedSrc,
	style: style,
	onBaseImageLoad,
	onUpgradedImageLoad,
	parallelLoading,
	blurHash,
	...props
}: PromotingImageProps) => {
	const [didLoadBase, setDidLoadBase] = useState(false);
	const [didLoadPromoted, setDidLoadPromoted] = useState(false);
	const [renderBase, setRenderBase] = useState(true);
	const { createClearingTimeout } = useClearingTimeouts();

	return (
		<View
			pointerEvents="box-none"
			style={[
				style,
				{
					position: "relative",
				},
			]}
		>
			{renderBase && (
				<Image
					alt={alt}
					src={src}
					// Only blurHash on the base image, otherwise we get a weird layered flash behavior
					blurHash={blurHash}
					style={{
						width: "100%",
						height: "100%",
					}}
					{...props}
					onLoad={(props) => {
						setDidLoadBase(true);
						onBaseImageLoad?.(props);
					}}
				/>
			)}
			{(didLoadBase || parallelLoading) && upgradedSrc && (
				<Image
					style={{
						position: "absolute",
						width: "100%",
						height: "100%",
						opacity: didLoadPromoted ? 1 : 0,
						zIndex: 1,
					}}
					alt={alt}
					src={upgradedSrc}
					onLoad={(props) => {
						setDidLoadPromoted(true);
						onBaseImageLoad?.(props);
						onUpgradedImageLoad?.(props);
						createClearingTimeout(() => {
							setRenderBase(false);
						}, 1000);
					}}
					{...props}
				/>
			)}
		</View>
	);
};
export default memo(PromotingImage);
